import { render, staticRenderFns } from "./AnalyticsArrowUp.vue?vue&type=template&id=3f5895d5&"
import script from "./AnalyticsArrowUp.vue?vue&type=script&lang=ts&"
export * from "./AnalyticsArrowUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports